import { createBrowserHistory } from 'history';

// Vite's BASE_URL always has a trailing slash; strip it for the history basename.
const basename = import.meta.env.BASE_URL.replace(/\/+$/, '');

export const appInsightsHistory = createBrowserHistory({ basename });
